<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <!-- <b-card>
      <b-row>
        <b-col md="12">
          <div v-if="updateType === 'firstUpdate'">
            You must change your password before logging on for the first time. Please update your password.
          </div>
          <div v-if="updateType === 'overtimeUpdate'">
            Your password is expired, please update your password.
          </div>
        </b-col>
      </b-row>
    </b-card> -->
    <b-card>
      <!-- form -->
      <b-form>
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <b-form-group
              label="Account"
              label-for="account-Account"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-account"
                  v-model="form.account"
                  name="Account"
                  :type="passwordFieldTypeOld"
                  placeholder="Account"
                />
                <!-- <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconOld"
                    class="cursor-pointer"
                    @click="togglePasswordOld"
                  />
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label-for="account-Email"
              label="Account Email"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-Email"
                  v-model="form.email"
                  :type="'email'"
                  name="Email"
                  placeholder="Email"
                />
                <!-- <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconNew"
                    class="cursor-pointer"
                    @click="togglePasswordNew"
                  />
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <span>If you forget your Email, please contact your administrator!</span>
          </b-col>

          <!-- <b-col md="6">
            <b-form-group
              label-for="account-retype-new-password"
              label="Retype New Password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-retype-new-password"
                  v-model="form.newPassword1"
                  :type="passwordFieldTypeRetype"
                  name="retype-password"
                  placeholder="New Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconRetype"
                    class="cursor-pointer"
                    @click="togglePasswordRetype"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              @click="changePassword"
            >
              Reset Password
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              class="mt-1"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import md5 from 'js-md5'
import { deepClone } from '@/util/util'
import { updatePassword, updatePasswordNoToken, resetPassword } from '@/api/user'
import { mapGetters } from 'vuex';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    // BInputGroupAppend,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    // 首次更新 firstUpdate 超时更新 overtimeUpdate
    updateType: {
      type: String,
      default: 'firstUpdate',
    },
  },
  data() {
    return {
      form: {
        account: '',
        email: '',
      },
      loading: false,
      passwordFieldTypeOld: 'email',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    ...mapGetters(['isInitPasswordFlag', 'userAllInfo', 'tempUserInfo']),
  },
  methods: {
    clear() {
      this.form = {
        account: '',
        email: '',
      }
    },
    changePassword() {
      this.loading = true
      const tempForm = deepClone(this.form)
      //   if (tempForm.newPassword === 'mcc123456') {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: this.$t('_default.toast.title'),
      //         icon: 'BellIcon',
      //         text: this.$t('_default.updatePassword.check1'),
      //         variant: 'danger',
      //       },
      //     })
      //     this.loading = false
      //     return
      //   }
      //   if (tempForm.oldPassword === tempForm.newPassword) {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: this.$t('_default.toast.title'),
      //         icon: 'BellIcon',
      //         text: this.$t('_default.updatePassword.check2'),
      //         variant: 'danger',
      //       },
      //     })
      //     this.loading = false
      //     return
      //   }
      //   if (tempForm.newPassword !== tempForm.newPassword1) {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: this.$t('_default.toast.title'),
      //         icon: 'BellIcon',
      //         text: this.$t('_default.updatePassword.check3'),
      //         variant: 'danger',
      //       },
      //     })
      //     this.loading = false
      //     return
      //   }
      // ^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$
      //   const header = {
      //     Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
      //     'Blade-Auth': `bearer ${this.tempUserInfo.access_token}`,
      //   }
      resetPassword(tempForm).then(res => {
        this.loading = false
        // this.$store.commit('getIsInitPassWordStatus', false)
        this.clear()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      }).catch(e => {
        this.loading = false
      })
    },
  },
}
</script>
